import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/otpgroup/complaint'
});
export default {
	init() {
		return httpClient.get('/init');
	},
	captcha() {
		return httpClient.get('/captcha');
	},
	upload(file) {
		const formData = new FormData();
		formData.append('file', file);
		return httpClient.post('/file-upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
	},
	deleteFile(filename) {
		return httpClient.delete(`/file-delete/${filename}`);
	},
	finalize(model) {
		return httpClient.post('/finalize', model);
	}
};
